import React from 'react';
import { CircularProgress } from '@mui/material';

export default ({ color, ...props }) => (
  <CircularProgress color={color || 'primary'} {...props} />
);
